import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  // Save cart to localStorage whenever cart updates
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  // Add to Cart function
  const addToCart = (product, selectedSize, selectedColor, quantity = 1) => {
    if (!product.price) {
      console.error("Product price is missing:", product);
      return;
    }
  
    const existingItemIndex = cart.findIndex(
      (item) =>
        item.product_id === product.product_id &&
        item.selectedSize === selectedSize &&
        item.selectedColor === selectedColor
    );
  
    if (existingItemIndex !== -1) {
      // If the item already exists, update the quantity
      const updatedCart = [...cart];
      updatedCart[existingItemIndex].quantity += quantity;
      updatedCart[existingItemIndex].totalPrice =
        parseFloat(product.price) * updatedCart[existingItemIndex].quantity;
      setCart(updatedCart);
    } else {
      // Otherwise, add a new item to the cart
      const updatedCart = [
        ...cart,
        {
          ...product,
          selectedSize,
          selectedColor,
          quantity,
          totalPrice: parseFloat(product.price) * quantity,
        },
      ];
      setCart(updatedCart);
    }
  };
  

  // Remove from Cart function
  const removeFromCart = (productId) => {
    const updatedCart = cart.filter((item) => item.product_id !== productId);
    setCart(updatedCart);
  };

  // Clear Cart function (for order success)
  const clearCart = () => {
    setCart([]);
    localStorage.removeItem("cart"); // Clear localStorage
  };

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, clearCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
